export default __webpack_public_path__ + "52ae4eb5f145a0b2fa7c1c89d4965662.png";